import React from "react";
import { cn } from "../../utils/lib";

export function OrdersIconSelected({ className, ...props }) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      className={cn("w-full h-auto", className)}
      {...props}
    >
      <path
        opacity="0.4"
        d="M16.6666 6.87435V14.9993C16.6666 17.4993 15.1749 18.3327 13.3333 18.3327H6.66659C4.82492 18.3327 3.33325 17.4993 3.33325 14.9993V6.87435C3.33325 4.16602 4.82492 3.54102 6.66659 3.54102C6.66659 4.05768 6.8749 4.52435 7.21656 4.86601C7.55823 5.20768 8.02492 5.41602 8.54159 5.41602H11.4583C12.4916 5.41602 13.3333 4.57435 13.3333 3.54102C15.1749 3.54102 16.6666 4.16602 16.6666 6.87435Z"
        fill="white"
      />
      <path
        d="M13.3334 3.54102C13.3334 4.57435 12.4917 5.41602 11.4584 5.41602H8.54175C8.02508 5.41602 7.55839 5.20768 7.21673 4.86601C6.87506 4.52435 6.66675 4.05768 6.66675 3.54102C6.66675 2.50768 7.50841 1.66602 8.54175 1.66602H11.4584C11.9751 1.66602 12.4418 1.87435 12.7834 2.21602C13.1251 2.55769 13.3334 3.02435 13.3334 3.54102Z"
        fill="white"
      />
      <path
        d="M10.0001 11.459H6.66675C6.32508 11.459 6.04175 11.1757 6.04175 10.834C6.04175 10.4923 6.32508 10.209 6.66675 10.209H10.0001C10.3417 10.209 10.6251 10.4923 10.6251 10.834C10.6251 11.1757 10.3417 11.459 10.0001 11.459Z"
        fill="white"
      />
      <path
        d="M13.3334 14.791H6.66675C6.32508 14.791 6.04175 14.5077 6.04175 14.166C6.04175 13.8243 6.32508 13.541 6.66675 13.541H13.3334C13.6751 13.541 13.9584 13.8243 13.9584 14.166C13.9584 14.5077 13.6751 14.791 13.3334 14.791Z"
        fill="white"
      />
    </svg>
  );
}
